import React, { FC, ReactNode } from 'react';

import { useAuth } from '../utils/AuthContext';
import { Role } from '../types';

type CanProps = {
  roles: Role[];
  children: ReactNode
}

const Can: FC<CanProps> = ({ roles, children }) => {
  const { status, user } = useAuth();

  // console.log('user from can', user);
  // console.log('roles from can', roles);

  if ((status === 'logged_out' && roles.includes('guest')) || 
    (status === 'logged_in' && user && roles.includes(user.role))
  ) {
    return <>{children}</>
  } else {
    return <></>
  } 
};

export default Can;